import firebase from "firebase/app"
import "firebase/firestore"

var firebaseConfig = {
  apiKey: "AIzaSyCQ1MVaz07k3lZMs_PxmEJbqOIhBgwpOFI",
  authDomain: "appointmentsystem-5e94e.firebaseapp.com",
  databaseURL: "https://appointmentsystem-5e94e.firebaseio.com",
  projectId: "appointmentsystem-5e94e",
  storageBucket: "appointmentsystem-5e94e.appspot.com",
  messagingSenderId: "843953090007",
  appId: "1:843953090007:web:2541379f24a670d1",
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

const database = firebase.firestore()

export { database }
